import { useMutation } from "@tanstack/react-query";
import { deleteEngagementBlueprint } from "PFCore/services/admin/engagement_blueprints";
import { Id } from "PFTypes";

import { mutationKeys } from "./mutation_keys";

export const useEngagementBlueprintDelete = () =>
  useMutation({
    mutationKey: mutationKeys.delete(),
    mutationFn: (id: Id) => deleteEngagementBlueprint(id)
  });
